(function (w, $) {
    'use strict';

    const assetId = '~/Parts/Views/User/SubscribeNewsletter.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {

        const $container = $('.' + ctx.containerSelector);
        const $emailInput = $container.find('.' + ctx.emailInputSelector);
        const $subscribeBtn = $container.find('.' + ctx.subscribeBtnSelector);

        let recaptcha2Invisible;
        w.PubSub.subscribe('recaptcha.callback.loaded', function () {
            recaptcha2Invisible = new w.Recaptcha2Invisible(ctx.recaptchaContainerId, ctx.recaptchaSitekey);
        });

        $emailInput.on('keypress',
            function(e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    $subscribeBtn.trigger('click');
                }
            });

        $emailInput.on('focus', () => { w.recaptcha_load(); });

        $subscribeBtn.click(function(evt) {
            evt.preventDefault();
            if (validate()) {
                recaptcha2Invisible.execute(
                    function (token) {
                        subscribe(token);
                    },
                    function (error) {
                        notify(error, "error");
                    }
                );
            }
        });

        function validate() {
            if (!/(.+)@(.+){2,}\.(.+){2,}/.test($emailInput.val())) {
                notify(ctx.labels.invalidEmail, "error");
                return false;
            }
            return true;
        }

        function subscribe(recaptcha2Token) {
            $.ajax({
                    url: w.R + 'handlers/public/userdata.ashx',
                    type: 'POST',
                    data: {
                        action: 'SubscribeToNewsletter',
                        email: $emailInput.val(),
                        groups: ctx.groups,
                        source: ctx.source,
                        languageID: ctx.languageID,
                        recaptcha2Token: recaptcha2Token
                    },
                    dataType: 'text'
                })
                .done(function() {
                    if (ctx.redirectUrl)
                        window.location.replace(window.R + ctx.redirectUrl);
                    else
                        notify(ctx.labels.successfullySubscribed, "success");
                })
                .fail(function(ex) {
                    let error = ex.statusText ? ex.statusText : 'Subscription failed due to unknown error';

                    try {
                        error = JSON.parse(ex.responseText).Message;
                    } catch (e) {
                    }

                    notify(error, "error");
                });
        }

        function notify(message, type) {
            const notyOptions = {
                layout: 'topCenter',
                type: type,
                maxVisible: 15,
                force: true,
                timeout: 5000,
                text: message
            };
            w.noty(notyOptions);
        }
    }
})(window, jQuery);